import { Box, Divider, Typography } from '@mui/material';
import { SPAN_FULL } from './medicationFormLayout';

/** A labelled rule between the form's sections, spanning the whole grid. */
export default function MedicationSectionDivider({
  label,
  testId,
}: {
  label: string;
  testId?: string;
}) {
  return (
    <Box sx={{ ...SPAN_FULL, mt: 1 }} data-testid={testId}>
      <Divider textAlign="left">
        <Typography variant="overline" color="text.secondary">
          {label}
        </Typography>
      </Divider>
    </Box>
  );
}
